export enum DrawerIDs {
  AclEntries = 'ACLEntriesDrawerId',
  UserGroupAclEntries = 'ACL EntryDrawerId',
  Claims = 'ClaimDrawerId',
  Role = 'RoleDrawerId',
  User = 'UserDrawerId',
  License = 'LicenseDrawerId',
  UserProfileAppTenants = 'UserProfileAppTenantsId',
  UserProfileClaims = 'userProfileClaimsId',
  UserProfileForeignSystems = 'UserProfileForeignSystemsId',
  UserProfileIdentities = 'UserProfileIdentitiesId',
  UserRoleMembership = 'UserRoleMembershipId',
  UserGroup = 'User GroupDrawerId',
  Users = 'New UserDrawerId',
  GlobalRoles = 'GlobalRolesId',
  UserProfileAcls = 'userAclsId'
}
